var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-flex",
    [
      _c(
        "h3",
        { staticClass: "headline" },
        [_c("v-list-item-title", [_vm._v("Filtro Ordini MTM")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("div", { staticClass: "text-h6" }, [
                    _vm._v("Numero Ordine"),
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "full-width": "",
                      placeholder: "Numero Ordine",
                      "hide-details": "",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.applicaModificaFiltro()
                      },
                    },
                    model: {
                      value: _vm.filtroNumeroOrdine,
                      callback: function ($$v) {
                        _vm.filtroNumeroOrdine = $$v
                      },
                      expression: "filtroNumeroOrdine",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "", "mt-lg-6": "" } },
                [
                  _c("div", { staticClass: "text-h6" }, [
                    _vm._v("Nominativo Cliente"),
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "full-width": "",
                      placeholder: "Nominativo Cliente",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.applicaModificaFiltro()
                      },
                    },
                    model: {
                      value: _vm.filtroNominativoCliente,
                      callback: function ($$v) {
                        _vm.filtroNominativoCliente = $$v
                      },
                      expression: "filtroNominativoCliente",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("div", { staticClass: "text-h6" }, [_vm._v("ID Cliente")]),
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "full-width": "",
                      placeholder: "ID Cliente",
                    },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.applicaModificaFiltro()
                      },
                    },
                    model: {
                      value: _vm.filtroIdCliente,
                      callback: function ($$v) {
                        _vm.filtroIdCliente = $$v
                      },
                      expression: "filtroIdCliente",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("div", { staticClass: "text-h6" }, [_vm._v("Stato")]),
                  _c("v-select", {
                    attrs: {
                      filled: "",
                      items: _vm.opzioniStato,
                      "item-text": "label",
                      "item-value": "value",
                    },
                    model: {
                      value: _vm.filtroStato,
                      callback: function ($$v) {
                        _vm.filtroStato = $$v
                      },
                      expression: "filtroStato",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "full-width": "",
                      filled: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      multiple: "",
                      label: "Filtro per stagioni",
                      items: _vm.stagioniFiltrate,
                      "search-input": _vm.searchStagione,
                      "item-text": "id",
                      "item-value": "id",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.searchStagione = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.searchStagione = $event
                      },
                    },
                    model: {
                      value: _vm.filtroStagioni,
                      callback: function ($$v) {
                        _vm.filtroStagioni = $$v
                      },
                      expression: "filtroStagioni",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      "full-width": "",
                      filled: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      multiple: "",
                      label: "Filtro per modelli",
                      items: _vm.modelliFiltrati,
                      "search-input": _vm.searchModello,
                      "item-text": "desc",
                      "item-value": "id",
                    },
                    on: {
                      "update:searchInput": function ($event) {
                        _vm.searchModello = $event
                      },
                      "update:search-input": function ($event) {
                        _vm.searchModello = $event
                      },
                    },
                    model: {
                      value: _vm.filtroModelli,
                      callback: function ($$v) {
                        _vm.filtroModelli = $$v
                      },
                      expression: "filtroModelli",
                    },
                  }),
                ],
                1
              ),
              _c("v-list-item-title", [_vm._v("Data consegna:")]),
              _c(
                "div",
                [
                  _c(
                    "v-menu",
                    {
                      ref: "menu1",
                      attrs: {
                        "offset-y": "",
                        transition: "scale-transition",
                        "max-width": "290px",
                        "min-width": "90px",
                        "close-on-content-click": false,
                        "nudge-right": 40,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      clearable: "",
                                      label: "da",
                                      "persistent-hint": "",
                                      "prepend-icon": "mdi-calendar",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.filtroDataConsegnaDa =
                                          _vm.parseDate(
                                            _vm.filtroDataConsegnaDaFormatted
                                          )
                                      },
                                    },
                                    model: {
                                      value: _vm.filtroDataConsegnaDaFormatted,
                                      callback: function ($$v) {
                                        _vm.filtroDataConsegnaDaFormatted = $$v
                                      },
                                      expression:
                                        "filtroDataConsegnaDaFormatted",
                                    },
                                  },
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.menu1,
                        callback: function ($$v) {
                          _vm.menu1 = $$v
                        },
                        expression: "menu1",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        on: {
                          input: function ($event) {
                            _vm.menu1 = false
                          },
                        },
                        model: {
                          value: _vm.filtroDataConsegnaDa,
                          callback: function ($$v) {
                            _vm.filtroDataConsegnaDa = $$v
                          },
                          expression: "filtroDataConsegnaDa",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-menu",
                    {
                      ref: "menu2",
                      attrs: {
                        "offset-y": "",
                        transition: "scale-transition",
                        "max-width": "290px",
                        "min-width": "90px",
                        "close-on-content-click": false,
                        "nudge-right": 40,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      clearable: "",
                                      label: "a",
                                      "persistent-hint": "",
                                      "prepend-icon": "mdi-calendar",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.filtroDataConsegnaA = _vm.parseDate(
                                          _vm.filtroDataConsegnaAFormatted
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.filtroDataConsegnaAFormatted,
                                      callback: function ($$v) {
                                        _vm.filtroDataConsegnaAFormatted = $$v
                                      },
                                      expression:
                                        "filtroDataConsegnaAFormatted",
                                    },
                                  },
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.menu2,
                        callback: function ($$v) {
                          _vm.menu2 = $$v
                        },
                        expression: "menu2",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        on: {
                          input: function ($event) {
                            _vm.menu2 = false
                          },
                        },
                        model: {
                          value: _vm.filtroDataConsegnaA,
                          callback: function ($$v) {
                            _vm.filtroDataConsegnaA = $$v
                          },
                          expression: "filtroDataConsegnaA",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-list-item-title", [_vm._v("Data consegna fornitore:")]),
              _c(
                "div",
                [
                  _c(
                    "v-menu",
                    {
                      ref: "menu1",
                      attrs: {
                        "offset-y": "",
                        transition: "scale-transition",
                        "max-width": "290px",
                        "min-width": "90px",
                        "close-on-content-click": false,
                        "nudge-right": 40,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      clearable: "",
                                      label: "da",
                                      "persistent-hint": "",
                                      "prepend-icon": "mdi-calendar",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.filtroRigaDataConsegnaFornitoreDa =
                                          _vm.parseDate(
                                            _vm.filtroRigaDataConsegnaFornitoreDaFormatted
                                          )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.filtroRigaDataConsegnaFornitoreDaFormatted,
                                      callback: function ($$v) {
                                        _vm.filtroRigaDataConsegnaFornitoreDaFormatted =
                                          $$v
                                      },
                                      expression:
                                        "filtroRigaDataConsegnaFornitoreDaFormatted",
                                    },
                                  },
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.menu3,
                        callback: function ($$v) {
                          _vm.menu3 = $$v
                        },
                        expression: "menu3",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        on: {
                          input: function ($event) {
                            _vm.menu3 = false
                          },
                        },
                        model: {
                          value: _vm.filtroRigaDataConsegnaFornitoreDa,
                          callback: function ($$v) {
                            _vm.filtroRigaDataConsegnaFornitoreDa = $$v
                          },
                          expression: "filtroRigaDataConsegnaFornitoreDa",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-menu",
                    {
                      ref: "menu2",
                      attrs: {
                        "offset-y": "",
                        transition: "scale-transition",
                        "max-width": "290px",
                        "min-width": "90px",
                        "close-on-content-click": false,
                        "nudge-right": 40,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      clearable: "",
                                      label: "a",
                                      "persistent-hint": "",
                                      "prepend-icon": "mdi-calendar",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.filtroRigaDataConsegnaFornitoreA =
                                          _vm.parseDate(
                                            _vm.filtroRigaDataConsegnaFornitoreAFormatted
                                          )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.filtroRigaDataConsegnaFornitoreAFormatted,
                                      callback: function ($$v) {
                                        _vm.filtroRigaDataConsegnaFornitoreAFormatted =
                                          $$v
                                      },
                                      expression:
                                        "filtroRigaDataConsegnaFornitoreAFormatted",
                                    },
                                  },
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.menu4,
                        callback: function ($$v) {
                          _vm.menu4 = $$v
                        },
                        expression: "menu4",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        on: {
                          input: function ($event) {
                            _vm.menu4 = false
                          },
                        },
                        model: {
                          value: _vm.filtroRigaDataConsegnaFornitoreA,
                          callback: function ($$v) {
                            _vm.filtroRigaDataConsegnaFornitoreA = $$v
                          },
                          expression: "filtroRigaDataConsegnaFornitoreA",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-list-item-title", [_vm._v("Data ordine di lancio:")]),
              _c(
                "div",
                [
                  _c(
                    "v-menu",
                    {
                      ref: "menu1",
                      attrs: {
                        "offset-y": "",
                        transition: "scale-transition",
                        "max-width": "290px",
                        "min-width": "90px",
                        "close-on-content-click": false,
                        "nudge-right": 40,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      clearable: "",
                                      label: "da",
                                      "persistent-hint": "",
                                      "prepend-icon": "mdi-calendar",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.filtroRigaDataChiusuraConsegnaDa =
                                          _vm.parseDate(
                                            _vm.filtroRigaDataChiusuraConsegnaDaFormatted
                                          )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.filtroRigaDataChiusuraConsegnaDaFormatted,
                                      callback: function ($$v) {
                                        _vm.filtroRigaDataChiusuraConsegnaDaFormatted =
                                          $$v
                                      },
                                      expression:
                                        "filtroRigaDataChiusuraConsegnaDaFormatted",
                                    },
                                  },
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.menu5,
                        callback: function ($$v) {
                          _vm.menu5 = $$v
                        },
                        expression: "menu5",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        on: {
                          input: function ($event) {
                            _vm.menu5 = false
                          },
                        },
                        model: {
                          value: _vm.filtroRigaDataChiusuraConsegnaDa,
                          callback: function ($$v) {
                            _vm.filtroRigaDataChiusuraConsegnaDa = $$v
                          },
                          expression: "filtroRigaDataChiusuraConsegnaDa",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-menu",
                    {
                      ref: "menu2",
                      attrs: {
                        "offset-y": "",
                        transition: "scale-transition",
                        "max-width": "290px",
                        "min-width": "90px",
                        "close-on-content-click": false,
                        "nudge-right": 40,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  {
                                    attrs: {
                                      clearable: "",
                                      label: "a",
                                      "persistent-hint": "",
                                      "prepend-icon": "mdi-calendar",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.filtroRigaDataChiusuraConsegnaA =
                                          _vm.parseDate(
                                            _vm.filtroRigaDataChiusuraConsegnaAFormatted
                                          )
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.filtroRigaDataChiusuraConsegnaAFormatted,
                                      callback: function ($$v) {
                                        _vm.filtroRigaDataChiusuraConsegnaAFormatted =
                                          $$v
                                      },
                                      expression:
                                        "filtroRigaDataChiusuraConsegnaAFormatted",
                                    },
                                  },
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.menu6,
                        callback: function ($$v) {
                          _vm.menu6 = $$v
                        },
                        expression: "menu6",
                      },
                    },
                    [
                      _c("v-date-picker", {
                        on: {
                          input: function ($event) {
                            _vm.menu6 = false
                          },
                        },
                        model: {
                          value: _vm.filtroRigaDataChiusuraConsegnaA,
                          callback: function ($$v) {
                            _vm.filtroRigaDataChiusuraConsegnaA = $$v
                          },
                          expression: "filtroRigaDataChiusuraConsegnaA",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.svuotaFiltro } },
                [_vm._v("Svuota")]
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { text: "" },
                  on: { click: _vm.annullaModificaFiltro },
                },
                [_vm._v("Annulla")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { text: "", color: "primary" },
                  on: { click: _vm.applicaModificaFiltro },
                },
                [_vm._v("Applica")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }